import type { AngusBaseEntity } from '../../core/models/angus-base-entity.model';
import type { ReportColumnConfig } from './report-column';
import type { ReportKey } from './reports/report.registry';
import type { LayoutOptions } from './reporting.model';

export enum ReportItemTypeKey {
    Layout = 1,
    Parameter = 2,
    Filter = 3,
    View = 4
}

export enum ReportItemScopeKey {
    System = 1,
    Subscriber = 2,
    User = 3
}

export interface ReportCategory {
    categoryKey: number | null;
    categoryName: string;
    reportKey: ReportKey;
    reportItemTypeKey: ReportItemTypeKey;
    reportItemScopeKey: ReportItemScopeKey;
    subscriberKey: number | null;
    userId: string | null;
    isUncategorized?: boolean;
}

export interface ReportItemEntity<TDefinition = unknown> extends AngusBaseEntity {
    itemKey: number | null;
    itemName: string;
    reportKey: ReportKey;
    reportItemTypeKey: ReportItemTypeKey;
    reportItemScopeKey: ReportItemScopeKey;
    subscriberKey: number | null;
    userId: string | null;
    categoryKey: number | null;
    itemDefinition: TDefinition | null;
}

export type ReportItemResponseDto = ReportItemEntity<string>;

export interface ReportViewEntity extends AngusBaseEntity {
    viewKey: number | null;
    viewName: string;
    reportKey: ReportKey;
    reportItemScopeKey: ReportItemScopeKey;
    subscriberKey: number | null;
    userId: string | null;
    categoryKey: number | null;
    layoutKey: number | null;
    parameterSetKey: number | null;
    filterSetKey: number | null;
}

export interface ReportItemCreateRequestDto<TDefinition = unknown> {
    itemName: string;
    reportItemTypeKey: ReportItemTypeKey;
    reportItemScopeKey: ReportItemScopeKey;
    subscriberKey: number | null;
    userId: string | null;
    categoryKey: number | null;
    itemDefinition: TDefinition | null;
}

export interface ReportItemDefinitionUpdateRequestDto<TDefinition = unknown> {
    itemDefinition: TDefinition | null;
}

export interface ReportItemMetadataUpdateRequestDto {
    itemName: string;
    reportItemScopeKey: ReportItemScopeKey;
    subscriberKey: number | null;
    userId: string | null;
    categoryKey: number | null;
}

export interface ReportItemShareRequestDto {
    recipientUserId: string;
}

export interface ReportViewUpsertRequestDto {
    viewName: string;
    reportItemScopeKey: ReportItemScopeKey;
    subscriberKey: number | null;
    userId: string | null;
    categoryKey: number | null;
    layoutKey: number | null;
    parameterSetKey: number | null;
    filterSetKey: number | null;
}

export interface LayoutDefinition {
    /**  Controls structural gird behavior such as pivot mode. */
    layoutOptions?: Partial<LayoutOptions>;

    /** Columns included in this layout with optional overrides. */
    columns: ReportColumnConfig[];
}

export type ParameterSetDefinition = Record<string, unknown>;

export type FilterSetDefinition = {
    searchTerm?: string;
    filterModel?: unknown;
}
